import { Box, ClickAwayListener, Popover } from "@mui/material";
import { Dashboard } from "../../../../../types/files";
import CustomFieldContentCard from "../../../../molecules/home-companies/CustomFieldContentCard";

const CustomFieldModal: React.FC<{
    open: boolean,
    dashboard: Dashboard,
    fieldName: string,
    newValue?: boolean,
    anchorElement?: HTMLElement|null,
    onClose: () => void,
 }> = ({ open, dashboard, fieldName, newValue, anchorElement, onClose }) => {
    return (<>
        <Popover open={open} anchorEl={anchorElement}
            PaperProps={{ sx: { borderRadius: '16px', overflow: 'hidden' } }}>
            <ClickAwayListener onClickAway={onClose}>
                <Box width="fit-content" height="fit-content">
                    <CustomFieldContentCard
                        newValue={newValue}
                        dashboard={dashboard}
                        fieldName={fieldName}
                        onClose={onClose}  />
                </Box>
            </ClickAwayListener>
        </Popover>
    </>);
}

export default CustomFieldModal;